// Espejo de los enums de Prisma (apps/api/prisma/schema.prisma).
// Si cambiás un enum en el schema, cambialo acá también.
export const Role = { OWNER: 'OWNER', MANAGER: 'MANAGER', STAFF: 'STAFF' };
export const ROLES = Object.values(Role);
export const Plan = { FREE: 'FREE', TRIAL: 'TRIAL', BASIC: 'BASIC', PRO: 'PRO' };
export const PLANS = Object.values(Plan);
export const PaymentMethod = {
    EFECTIVO: 'EFECTIVO',
    DEBITO: 'DEBITO',
    CREDITO: 'CREDITO',
    TRANSFERENCIA: 'TRANSFERENCIA',
    MERCADOPAGO: 'MERCADOPAGO',
    OTRO: 'OTRO',
};
export const PAYMENT_METHODS = Object.values(PaymentMethod);
export const SaleStatus = { COMPLETED: 'COMPLETED', VOIDED: 'VOIDED' };
export const SALE_STATUSES = Object.values(SaleStatus);
export const ExpenseCategory = {
    INSUMOS: 'INSUMOS',
    SUELDOS: 'SUELDOS',
    ALQUILER: 'ALQUILER',
    SERVICIOS: 'SERVICIOS',
    OTROS: 'OTROS',
};
export const EXPENSE_CATEGORIES = Object.values(ExpenseCategory);
export const PriceChangeReason = { MANUAL: 'MANUAL', BULK: 'BULK', REVERT: 'REVERT' };
export const PRICE_CHANGE_REASONS = Object.values(PriceChangeReason);
export const DomainStatus = {
    PENDING_DNS: 'PENDING_DNS',
    PENDING_SSL: 'PENDING_SSL',
    ACTIVE: 'ACTIVE',
    ERROR: 'ERROR',
    REMOVED: 'REMOVED',
};
export const DOMAIN_STATUSES = Object.values(DomainStatus);
/** Fase 2 (inventario). Sin endpoints todavía. */
export const StockMovementType = {
    PURCHASE: 'PURCHASE',
    SALE: 'SALE',
    ADJUSTMENT: 'ADJUSTMENT',
    WASTE: 'WASTE',
};
/** Rubro del local (no es enum de Prisma: se guarda como String en Local.businessType). */
export const BusinessType = {
    HELADERIA: 'HELADERIA',
    CAFETERIA: 'CAFETERIA',
    RESTAURANTE: 'RESTAURANTE',
    PANADERIA: 'PANADERIA',
    BAR: 'BAR',
    OTRO: 'OTRO',
};
export const BUSINESS_TYPES = Object.values(BusinessType);
export const ROLE_LABELS = {
    OWNER: 'Dueño/a',
    MANAGER: 'Encargado/a',
    STAFF: 'Empleado/a',
};
export const PLAN_LABELS = {
    FREE: 'Gratis',
    TRIAL: 'Prueba',
    BASIC: 'Básico',
    PRO: 'Pro',
};
export const PAYMENT_METHOD_LABELS = {
    EFECTIVO: 'Efectivo',
    DEBITO: 'Débito',
    CREDITO: 'Crédito',
    TRANSFERENCIA: 'Transferencia',
    MERCADOPAGO: 'Mercado Pago',
    OTRO: 'Otro',
};
export const EXPENSE_CATEGORY_LABELS = {
    INSUMOS: 'Insumos',
    SUELDOS: 'Sueldos',
    ALQUILER: 'Alquiler',
    SERVICIOS: 'Servicios',
    OTROS: 'Otros',
};
export const BUSINESS_TYPE_LABELS = {
    HELADERIA: 'Heladería',
    CAFETERIA: 'Cafetería',
    RESTAURANTE: 'Restaurante',
    PANADERIA: 'Panadería',
    BAR: 'Bar',
    OTRO: 'Otro',
};
export const DAY_LABELS = [
    'Domingo',
    'Lunes',
    'Martes',
    'Miércoles',
    'Jueves',
    'Viernes',
    'Sábado',
];
//# sourceMappingURL=enums.js.map